import { ScaleElement } from '@scale/base-element';
import { CartAPI } from '@scale/cart-api';

class ScaleCartItem extends ScaleElement {
  get #key() {
    return this.dataset.key;
  }

  get #quantity() {
    return Number(this.dataset.quantity) || 0;
  }

  setup() {
    const input = this.ref('quantity-input');
    if (!input) return;

    const submit = () => {
      const value = parseInt(input.value, 10);
      if (Number.isNaN(value) || value < 0) return;
      if (value === 0) {
        this.remove();
      } else if (value !== this.#quantity) {
        this.#changeQuantity(value);
      }
    };

    input.addEventListener('change', submit, { signal: this.signal });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.blur();
        submit();
      }
    }, { signal: this.signal });
  }

  // --- Quantity ---

  increment() {
    this.#changeQuantity(this.#quantity + 1);
  }

  decrement() {
    const newQty = this.#quantity - 1;
    if (newQty <= 0) {
      this.remove();
      return;
    }
    this.#changeQuantity(newQty);
  }

  remove() {
    this.#changeQuantity(0);
  }

  async #changeQuantity(quantity) {
    this.#setLoading(true);

    try {
      const sectionId = this.dataset.sectionId;
      await CartAPI.change(this.#key, quantity, { sections: sectionId ? [sectionId] : [] });
      this.announce(`${Scale.translations.quantity || 'Quantity'}: ${quantity}`, 'polite');
    } catch (err) {
      if (err?.name !== 'AbortError') {
        this.#setLoading(false);
      }
    }
  }

  #setLoading(loading) {
    this.closest('.cart-item')?.classList.toggle('cart-item--loading', loading);
  }
}

if (!customElements.get('scale-cart-item')) {
  customElements.define('scale-cart-item', ScaleCartItem);
}
